import React from 'react';

import randomstring from 'uuid/v4';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

class Index extends React.Component {

    state = {
        oculto: false,
        open: this.props.options.indexOf(1) >= 0,
        out: this.props.options.indexOf(2) >= 0,
        closed: this.props.options.indexOf(3) >= 0,
        closedout: this.props.options.indexOf(4) >= 0,
        novalue: this.props.options.indexOf(5) >= 0,
        correct: this.props.options.indexOf(6) >= 0
    }

    render() {

        const { oculto, open, closed, out, closedout, novalue, correct } = this.state;
        const { family } = this.props;

        console.log(open, closed, out, closedout, novalue);

        return <div key={randomstring()} className="flex_auto_column margin_bottom_48">
            <div className="flex_full_row padding_borders_flat bg_cool_grey_two c_white uppercase">
                <span className="flex_full_row">{family.familia}</span>
                {!oculto
                    ? <ExpandLess className="hand c_white" onClick={() => { this.setState({ oculto: !oculto }) }} />
                    : <ExpandMore className="hand c_white" onClick={() => { this.setState({ oculto: !oculto }) }} />
                }
            </div>
            {!oculto &&
                family.procesos
                    .sort((a, b) => a.proceso.toUpperCase() > b.proceso.toUpperCase() ? 1 : -1)
                    .map((proceso) =>
                        <div key={randomstring()} className="flex_full_column margin_top_12">
                            <div className="flex_full_row uppercase bg_bluish c_white padding_4 padding_left_12">
                                {proceso.proceso}
                            </div>
                            <div className="flex_full_row wrap ">
                                {
                                    proceso.instancias
                                        .sort((a, b) => a.creada > b.creada ? 1 : -1)
                                        .map((i) =>
                                            <div key={randomstring()}
                                                onClick={this.props.onClick(family.familia, i)}
                                                className={"buttontime margin_top_6 margin_right_12 hand "
                                                    + (i.cerrada ?
                                                        i.fueraPlazo
                                                            ? "bg_lipstickligth c_white " + (closedout ? "" : "popuphide")
                                                            : "bg_pea c_white " + (closed ? "" : "popuphide")
                                                        : i.fueraPlazo
                                                            ? "bg_dark_grey_blue c_white " + (out ? "" : "popuphide")
                                                            : "bg_white c_greyish_brown " + (open ? "" : "popuphide")
                                                    )
                                                    + (i.tareasNo
                                                        ? " boderred " + (novalue ? "" : "popuphide")
                                                        : " border " + (correct ? "" : "popuphide")
                                                    )
                                                }>
                                                <span>{i.creada.split(" ")[1].substring(0, 5)}</span>
                                            </div>
                                        )
                                }
                            </div>
                        </div>
                    )
            }
        </div>
    }
}
export default Index;


// WEBPACK FOOTER //
// ./src/components/complex/reports/visibility/Family.js